import { Link } from "react-router-dom";
import {
  Zap, Flame, Wifi, FileText, ArrowRight, Check, ShieldCheck,
  Landmark, Car, Home as HomeIcon, Heart, Sparkles, Star,
} from "lucide-react";

const hero = "https://images.unsplash.com/photo-1556566353-cdcb88a69f3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwzfHxmYW1pbHklMjByZWxheGluZyUyMGhvbWUlMjBicmlnaHR8ZW58MHx8fHwxNzkxMzUzOTU1fDA&ixlib=rb-4.1.0&q=85";

const verticals = [
  {
    to: "/utenze",
    icon: Zap,
    tag: "Utenze",
    title: "Luce, gas e fibra senza pensieri",
    desc: "Controllo bollette, volture, subentri, reclami, rateizzazioni e contratti non richiesti.",
    color: "#10B981",
    testid: "home-card-utenze",
  },
  {
    to: "/credito",
    icon: Landmark,
    tag: "Credito",
    title: "Supporto credito per abbonati",
    desc: "Ti affianchiamo nella raccolta e verifica dei documenti per finanziamenti, mutui e cessione del quinto.",
    color: "#0A192F",
    testid: "home-card-credito",
  },
  {
    to: "/assicurazioni",
    icon: ShieldCheck,
    tag: "Assicurazioni",
    title: "Preventivi gratuiti per tutti",
    desc: "Auto, moto, casa e vita. Preventivi gratuiti anche senza abbonamento.",
    color: "#F97316",
    testid: "home-card-assicurazioni",
  },
];

const utenzeIcons = [
  { icon: Zap, label: "Luce" },
  { icon: Flame, label: "Gas" },
  { icon: Wifi, label: "Fibra" },
  { icon: FileText, label: "Bollette" },
];

export default function Home() {
  return (
    <div data-testid="home-page">
      {/* HERO */}
      <section className="relative overflow-hidden bg-white">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 py-20 lg:grid-cols-2 lg:gap-16 lg:px-8 lg:py-28">
          <div className="vt-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-[#F8FAFC] px-4 py-1.5 text-xs font-bold uppercase tracking-[0.15em] text-slate-600">
              <Sparkles className="h-3.5 w-3.5 text-[#10B981]" /> Vivi senza pensieri
            </span>
            <h1 className="mt-6 font-display text-4xl font-extrabold leading-[1.08] tracking-tighter text-[#0A192F] sm:text-5xl lg:text-6xl">
              Quanto vale la tua serenità?{" "}
              <span className="text-[#10B981]">Con noi, non sei solo.</span>
            </h1>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
              ViviTranquillo ti affianca ogni giorno: controlliamo le tue bollette, ti supportiamo
              nelle pratiche di credito e troviamo l'assicurazione giusta per te.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/piano"
                data-testid="hero-piano-btn"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-[#10B981] px-8 py-3.5 font-semibold text-white transition-colors hover:bg-[#059669]"
              >
                Tutelami <ArrowRight className="h-4 w-4" />
              </Link>
              <Link
                to="/assicurazioni"
                data-testid="hero-quote-btn"
                className="inline-flex items-center justify-center gap-2 rounded-full border-2 border-slate-200 px-8 py-3.5 font-semibold text-[#0A192F] transition-colors hover:border-[#0A192F]"
              >
                Preventivo gratuito
              </Link>
            </div>
            <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-500">
              <span className="inline-flex items-center gap-2"><Check className="h-4 w-4 text-[#10B981]" /> 3 richieste annuali</span>
              <span className="inline-flex items-center gap-2"><Check className="h-4 w-4 text-[#10B981]" /> Assistenza tutto l'anno</span>
              <span className="inline-flex items-center gap-2"><Check className="h-4 w-4 text-[#10B981]" /> Preventivi assicurativi gratuiti</span>
            </div>
          </div>

          <div className="vt-fade-up relative" style={{ animationDelay: "0.15s" }}>
            <div className="overflow-hidden rounded-[2rem] border border-slate-200 shadow-[0_20px_60px_rgb(10,25,47,0.12)]">
              <img src={hero} alt="Famiglia che vive serena a casa" className="h-[420px] w-full object-cover" />
            </div>
            <div className="absolute -bottom-6 -left-6 hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-[0_8px_30px_rgb(0,0,0,0.08)] sm:block">
              <div className="flex items-center gap-3">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#10B981]/10">
                  <ShieldCheck className="h-6 w-6 text-[#10B981]" />
                </span>
                <div>
                  <p className="font-display text-lg font-bold text-[#0A192F]">€49<span className="text-sm font-medium text-slate-500">/anno</span></p>
                  <p className="text-xs text-slate-500">1 anno di Tranquillità</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* RECENSIONI */}
      <section data-testid="home-reviews" className="bg-white py-20 lg:py-28 border-t border-slate-100">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="flex flex-col items-center text-center">
            <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-[#F8FAFC] px-4 py-1.5">
              <div className="flex items-center gap-0.5">
                {[0, 1, 2, 3, 4].map((i) => (
                  <Star key={i} className="h-4 w-4 fill-[#FBBF24] text-[#FBBF24]" />
                ))}
              </div>
              <span className="text-sm font-bold text-[#0A192F]">4,9/5</span>
              <span className="text-sm text-slate-500">· migliaia di recensioni</span>
            </div>
            <h2 className="mt-6 max-w-3xl font-display text-3xl font-bold tracking-tight text-[#0A192F] sm:text-4xl">
              Oltre <span className="text-[#10B981]">45.000 famiglie</span> si fidano di noi
            </h2>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-600">
              Dietro ogni pratica c'è una persona. Aiutiamo davvero le persone, ogni giorno, con
              attenzione e umanità. Ecco cosa raccontano i nostri clienti.
            </p>
          </div>

          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {[
              { n: "Maria R.", c: "Napoli", t: "Mi hanno risolto un problema con la bolletta della luce che trascinavo da mesi. Gentilissimi e sempre presenti.", img: "https://static.prod-images.emergentagent.com/jobs/817e9603-e33f-4843-9e20-5308e3338988/images/3b2303888ea2329ae25e6511f67d1a55fd6f6d34d205200e23051c1f9be7923b.jpeg" },
              { n: "Giuseppe T.", c: "Bari", t: "Finalmente qualcuno che ti spiega le cose con calma. Mi sono sentito seguito passo dopo passo.", img: "https://static.prod-images.emergentagent.com/jobs/817e9603-e33f-4843-9e20-5308e3338988/images/7c5b2dcf5ac4dfee9791bf4543551750f36881211fe5fd62c96048bd2f78195b.jpeg" },
              { n: "Anna L.", c: "Roma", t: "Ho risparmiato sull'assicurazione auto e non ho dovuto fare quasi nulla. Consigliatissimi.", img: "https://static.prod-images.emergentagent.com/jobs/817e9603-e33f-4843-9e20-5308e3338988/images/2e23adfb25af6304898705df373c832fee8cc2c35d09c05386616875b3fd4746.jpeg" },
              { n: "Francesco M.", c: "Milano", t: "Per la pratica del mutuo mi hanno aiutato con tutti i documenti. Professionali e umani.", img: "https://static.prod-images.emergentagent.com/jobs/817e9603-e33f-4843-9e20-5308e3338988/images/49fdea09006f0b9377391f7112bbf2f466891a6fdbd5853f6ffc02b766fa2574.jpeg" },
              { n: "Carmela D.", c: "Palermo", t: "Avevo un contratto non richiesto, se ne sono occupati di tutto loro. Che sollievo!", img: "https://static.prod-images.emergentagent.com/jobs/817e9603-e33f-4843-9e20-5308e3338988/images/bd9e8a8a8e3f893f0e4d8d8a71226a44cd821d665f340f6a77c643c039cf7804.jpeg" },
              { n: "Salvatore P.", c: "Catania", t: "Pensavo fosse complicato, invece è bastata una telefonata. Mi fido ciecamente di loro.", img: "https://static.prod-images.emergentagent.com/jobs/817e9603-e33f-4843-9e20-5308e3338988/images/a7a296a0cccab995bd44947e7560c9dee65c602238859c9faca042567ee27721.jpeg" },
            ].map((r, idx) => (
              <div key={idx} data-testid={`home-review-${idx}`} className="flex flex-col rounded-2xl border border-slate-200 bg-[#F8FAFC] p-6">
                <div className="flex items-center gap-0.5">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <Star key={i} className="h-4 w-4 fill-[#FBBF24] text-[#FBBF24]" />
                  ))}
                </div>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-700">“{r.t}”</p>
                <div className="mt-5 flex items-center gap-3">
                  <img
                    src={r.img}
                    alt={`Ritratto illustrativo di ${r.n}`}
                    loading="lazy"
                    decoding="async"
                    width="48"
                    height="48"
                    className="h-11 w-11 flex-shrink-0 rounded-full object-cover"
                  />
                  <div>
                    <p className="text-sm font-bold text-[#0A192F]">{r.n}</p>
                    <p className="text-xs text-slate-400">{r.c}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <p className="mt-10 text-center text-sm text-slate-500">
            E migliaia di altre famiglie che ogni giorno scelgono di vivere più serene con noi.
          </p>
        </div>
      </section>

      <section className="bg-[#F8FAFC] py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-2xl">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#10B981]">I nostri servizi</span>
            <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-[#0A192F] sm:text-4xl">
              Tre aree, un unico punto di riferimento
            </h2>
          </div>
          <div className="mt-12 grid gap-6 lg:grid-cols-3">
            {verticals.map((v) => (
              <Link
                key={v.to}
                to={v.to}
                data-testid={v.testid}
                className="group flex flex-col items-start gap-4 rounded-2xl border border-slate-200 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)]"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl" style={{ backgroundColor: `${v.color}1a` }}>
                  <v.icon className="h-6 w-6" style={{ color: v.color }} />
                </span>
                <span className="text-xs font-bold uppercase tracking-[0.15em] text-slate-400">{v.tag}</span>
                <h3 className="font-display text-xl font-bold text-[#0A192F]">{v.title}</h3>
                <p className="text-sm leading-relaxed text-slate-600">{v.desc}</p>
                <span className="mt-2 inline-flex items-center gap-1.5 text-sm font-semibold text-[#10B981]">
                  Scopri di più <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* UTENZE STRIP */}
      <section className="bg-white py-20 lg:py-28">
        <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 lg:grid-cols-2 lg:px-8">
          <div>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#10B981]">Utenze</span>
            <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-[#0A192F] sm:text-4xl">
              Non lasciare che le bollette ti complichino la vita
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-slate-600">
              Controlliamo i tuoi contratti di luce, gas e fibra, gestiamo volture e subentri,
              ti aiutiamo con reclami, rateizzazioni e contratti non richiesti.
            </p>
            <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {utenzeIcons.map((u) => (
                <div key={u.label} className="flex flex-col items-center gap-2 rounded-xl border border-slate-200 bg-[#F8FAFC] py-5">
                  <u.icon className="h-6 w-6 text-[#10B981]" />
                  <span className="text-sm font-semibold text-[#0A192F]">{u.label}</span>
                </div>
              ))}
            </div>
            <Link to="/utenze" data-testid="home-utenze-cta" className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0A192F] px-7 py-3 font-semibold text-white transition-colors hover:bg-slate-800">
              Vai alle utenze <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
          <div className="grid gap-4">
            {["Controllo bollette", "Volture e subentri", "Reclami e rateizzazioni", "Contratti non richiesti"].map((t, i) => (
              <div key={t} className="flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5 shadow-[0_4px_20px_rgb(0,0,0,0.03)]">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#10B981] text-sm font-bold text-white">{i + 1}</span>
                <span className="font-semibold text-[#0A192F]">{t}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ASSICURAZIONI STRIP */}
      <section className="bg-[#F8FAFC] py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-2xl">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#F97316]">Assicurazioni</span>
            <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-[#0A192F] sm:text-4xl">
              Preventivi gratuiti, anche senza abbonamento
            </h2>
          </div>
          <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {[{ icon: Car, label: "Auto" }, { icon: Car, label: "Moto" }, { icon: HomeIcon, label: "Casa" }, { icon: Heart, label: "Vita" }].map((a) => (
              <Link key={a.label} to="/assicurazioni" data-testid={`home-ins-${a.label.toLowerCase()}`} className="group flex flex-col items-start gap-4 rounded-2xl border border-slate-200 bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)]">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#F97316]/10">
                  <a.icon className="h-5 w-5 text-[#F97316]" />
                </span>
                <span className="font-display text-lg font-bold text-[#0A192F]">{a.label}</span>
                <span className="text-sm font-semibold text-[#10B981]">Preventivo gratuito →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* GARANZIA */}
      <section className="bg-white py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="flex flex-col items-center gap-6 rounded-[2rem] border border-slate-200 bg-[#F8FAFC] px-8 py-12 text-center lg:flex-row lg:gap-10 lg:px-16 lg:text-left">
            <span className="flex h-16 w-16 flex-shrink-0 items-center justify-center rounded-2xl bg-[#10B981]">
              <ShieldCheck className="h-8 w-8 text-white" strokeWidth={2.2} />
            </span>
            <div>
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#10B981]">Soddisfatti o rimborsati</span>
              <h2 className="mt-2 font-display text-2xl font-bold tracking-tight text-[#0A192F] sm:text-3xl">
                Se con la nostra offerta paghi di più, ti rimborsiamo la differenza
              </h2>
              <p className="mt-3 max-w-2xl text-base leading-relaxed text-slate-600">
                Il rimborso della differenza avviene secondo le condizioni previste dalla garanzia ViviTranquillo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* PIANO CTA */}
      <section className="bg-white py-20 lg:py-28">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="overflow-hidden rounded-[2rem] bg-[#0A192F] px-8 py-14 lg:px-16 lg:py-16">
            <div className="grid items-center gap-10 lg:grid-cols-2">
              <div>
                <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#10B981]">Piano ViviTranquillo</span>
                <h2 className="mt-3 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
                  Tutto incluso a <span className="text-[#10B981]">€49</span>/anno
                </h2>
                <ul className="mt-6 space-y-3">
                  {["3 richieste annuali", "Assistenza utenze", "Supporto credito", "Area Clienti dedicata", "Assistenza durante l'anno"].map((f) => (
                    <li key={f} className="flex items-center gap-3 text-slate-200">
                      <Check className="h-5 w-5 flex-shrink-0 text-[#10B981]" /> {f}
                    </li>
                  ))}
                </ul>
                <p className="mt-6 text-sm text-slate-400">I preventivi assicurativi restano gratuiti e separati.</p>
              </div>
              <div className="flex justify-center lg:justify-end">
                <div className="w-full max-w-sm rounded-2xl bg-white p-8 text-center">
                  <p className="font-display text-5xl font-extrabold text-[#0A192F]">€49<span className="text-lg font-medium text-slate-400">/anno</span></p>
                  <p className="mt-2 text-sm text-slate-500">Un unico abbonamento, tutto l'anno sereno.</p>
                  <Link to="/piano" data-testid="home-piano-cta" className="mt-6 block rounded-full bg-[#10B981] px-8 py-3.5 font-semibold text-white transition-colors hover:bg-[#059669]">
                    Tutelami
                  </Link>
                  <Link to="/registrazione" data-testid="home-register-cta" className="mt-3 block rounded-full border-2 border-slate-200 px-8 py-3.5 font-semibold text-[#0A192F] transition-colors hover:border-[#0A192F]">
                    Crea il tuo account
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
